define('views/modules/calendar/animated-session/exercise/weight/history/weight-history-row',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    'services/unit-converter',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/history/weight-history-row.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    UnitConverter,
    // templates
    TWeightHistoryRow
) {

    var VWeightHistoryRow = Backbone.View.extend({
        template: TWeightHistoryRow,

        regions: {
            reps: ".reps-col",
            load: ".load-col",
            rest: ".rest-col"
        },

        initialize: function(opt) {
            this.options = opt || {};
        },

        render: function() {
            var LoadValue = UnitConverter.convert(this.options.model.load.value, this.options.model.load.unit, User.get('weightUnit'));

            this.setElement(Mustache.render(this.template, Mustache.getContext({
              setIndex: this.options.setIndex,
              reps: this.options.model.reps,
              rest: this.getRest(),
              convertedLoadValue: LoadValue,
              user_weightUnit: User.get('weightUnit')
            })));

            this.generateZones();

            this.setConvertedLoadValue();

            return this;
        },

        setConvertedLoadValue: function() {
            //this.zone.$loadInput.val(this.model.get('convertedLoadValue'));
          },

        getRest: function() {
            var val = this.options.model.rest;
            var s = val % 60;
            var m = Math.floor(val / 60) % 60;
            var h = Math.floor(val / 3600);

            return (h ? '' + h + ':' : '') + (h > 0 && m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' + s : s);
        }

      });

    return VWeightHistoryRow;

});

